const collapsibleRegionPresenter = require('./collapsibleRegionPresenter');
const packagePresenter = require('./packagesPresenter/packagePresenter');
const { deactivate } = require('gui');
const { getTranslationDictionary } = require('core');

module.exports = function packagesPresenter(packages = [], packageEvents = []) {
    const c = {};
    const packagesString = getTranslationDictionary().packages;
    const packagesRegionPresenter = collapsibleRegionPresenter(packagesString);
    const view = require('./packagesPresenter.tpl.html');
    const deactivator = deactivate();

    c.activate = function(region) {
        if(packageEvents.length > 0)
            return;
        if(packages.length <= 0)
            return;

        packagesRegionPresenter.activate(region);
        deactivator.add(packagesRegionPresenter);
        const contentRegion = packagesRegionPresenter.contentRegion();
        view.activate(contentRegion);
        deactivator.add(view);

        packages.forEach(pack => {
            const presenter = packagePresenter(pack);
            presenter.activate(view.wrapper);
            deactivator.add(presenter);
        });
    };

    c.deactivate = function() {
        deactivator();
    };

    return c;
};